<template>
  <wui-select
    :model-value="innerValue"
    data-test="black-white-list-type-select"
    :items="typeItems"
    @update:model-value="onChange"
  />
</template>
<script setup lang="ts">
import { SelectItem, WuiSelect } from '@wui/common-library'
import { computed, ref, watch } from 'vue'

import { BlackWhiteListType } from '@/entities/black-white-list'

import { useLocalization } from '@/shared/composables/localization'

const props = defineProps<{
  modelValue: BlackWhiteListType
}>()

const emit = defineEmits<{
  (event: 'update:modelValue', value: BlackWhiteListType): void
}>()

const onChange = (value: string | number) => {
  emit('update:modelValue', value as BlackWhiteListType)
}

const { t } = useLocalization()
const innerValue = ref(props.modelValue)

const typeItems = computed<SelectItem[]>(() => [
  {
    label: t('callsSettings.whiteList'),
    value: 'white',
  },
  {
    label: t('callsSettings.blackList'),
    value: 'black',
  },
])

watch(() => props.modelValue, () => {
  innerValue.value = props.modelValue
})
</script>
